export default __webpack_public_path__ + "static/media/julyDom2023Article.68522d6e.jpg";